import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FranchiseIncomeAccountsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `CommissionPlanTemplate/IncomeAccounts/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);            


    const value = { listRecords, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFranchiseIncomeAccountsStore = () => React.useContext(Context);
